import '../app-layout/app-layout';
import '../../components/spinner-overlay';

import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { until } from 'lit-html/directives/until.js';
import { LitElementStateService } from '@stefanholzapfel/lit-state';
import { TranslateService } from '../../services/translate.service';
import { styles } from './loading.styles';
import {DataService} from '../../services/api/data.service';
import {UserConfig} from '../../../../../backend/src/api/queries/user-config.query';
import {
    createNetworkCapabilities,
    createNetworkedList, NetworkedList,
    NetworkingCapability
} from '../../utils/data.utils';
import {Site} from '../../../../../backend/src/api/queries/site.query';
import {Report} from '../../../../../backend/src/api/queries/reports.query';
import {AccumulatedReport} from '../../../../../backend/src/api/queries/accumulated-reports.query';

export let globalStateService: LitElementStateService<State>;

@customElement('lit-loading')
export class Loading extends LitElement {
    
    static get styles() {
        return [
            styles
        ];
    }
    
    @property({ type: Object })
    private initializing: Promise<any> = null;
    
    protected render() {
        if (this.initializing) {
            return html`
                ${ until(
                    this.initializing.then(res => html`<lit-app-layout></lit-app-layout>`),
                    html`<spinner-overlay></spinner-overlay>`
                ) }
            `;
        }
    }
    
    protected firstUpdated() {
        const params = new URLSearchParams(window.location.search);
        const id = params.get('id');
        if (id) {
            localStorage.setItem('id', id);
            history.replaceState && history.replaceState(
                null, '', location.pathname + location.search.replace(/[\?&]id=[^&]+/, '').replace(/^&/, '?')
            );
        }
        globalStateService = new LitElementStateService<State>(
            {
                app: {
                    mobile: false,
                    language: 'de-DE',
                    previousRoute: '/',
                    currentRoute: '/',
                    userConfig: createNetworkCapabilities(['_fetch'])
                },
                components: {
                    form: {
                        site: createNetworkCapabilities(['_fetch']),
                        reports: createNetworkedList(['_fetch'], []),
                        report1: createNetworkCapabilities(['_fetch', '_add']),
                        report2: createNetworkCapabilities(['_fetch', '_add'])
                    },
                    list: {
                        reports: createNetworkedList(['_fetch'], [])
                    },
                    detail: {
                        reports: createNetworkedList(['_fetch'], [])
                    }
                }
            },
            {
                global: true
            }
        );
        this.initializing = Promise.all([
            DataService.init(),
            TranslateService.init('de-DE')
        ]);
    }
}

export interface State {
    app: {
        mobile: Boolean;
        language: String;
        previousRoute: String;
        currentRoute: String;
        userConfig: UserConfig & NetworkingCapability<'_fetch'>;
    };
    components: {
        form: {
            site: Site & NetworkingCapability<'_fetch'>,
            reports: NetworkedList<Report> & NetworkingCapability<'_fetch'>,
            report1: Report & NetworkingCapability<'_fetch'>  & NetworkingCapability<'_add'>,
            report2: Report & NetworkingCapability<'_fetch'>  & NetworkingCapability<'_add'>
        };
        list: {
            reports: NetworkedList<AccumulatedReport> & NetworkingCapability<'_fetch'>
        };
        detail: {
            reports: NetworkedList<Report> & NetworkingCapability<'_fetch'>
        };
    };
}
